import styled from 'styled-components'

export const PageContainer = styled.div`
  /* T2-6194: full-width white shell; content left-aligned under navbar (12px). */
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: calc(100vh - 56px);
  box-sizing: border-box;
  background: var(--common-white-main, #fff);
`

export const Content = styled.div`
  /* Title + form centered; only TalentBackButton (sibling) stays left under the logo. */
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 0 12px 1.5rem;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 0 20px 1.5rem;
  }
`

export const PageTitle = styled.h1`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0.25rem 0 0.75rem;
  color: rgba(0, 0, 0, 0.87);
  font-family: var(--fontMain, Poppins), sans-serif;
`

export const Section = styled.section`
  background: var(--common-white-main, #fff);
  border: 1px solid var(--divider, #e0e0e0);
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`

export const Title = styled.h2`
  font-size: 1.25rem;
  margin: 0 0 0.25rem 0;
  color: var(--primary-blue, #0B4598);
`

export const Subtitle = styled.p`
  margin: 0 0 0.75rem 0;
  color: var(--text-secondary, #666);
`

export const FieldGroup = styled.div`
  margin-bottom: 0.75rem;
`

export const RadiosTitle = styled.h3`
  font-size: 1rem;
  margin: 0 0 0.5rem 0;
  color: var(--text-primary, #222);
`

export const HelperText = styled.div`
  margin-top: 0.375rem;
  font-size: 0.875rem;
  color: var(--text-secondary, #666);
`

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
`

export const ResponsiveIframeWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding-top: min(56.25%, 225px); /* 16:9 aspect ratio, but capped at 225px height */
  border-radius: 12px;
  overflow: hidden;
  background: #000;
`

export const ResponsiveIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`

export const VideoExternalButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 48px;
  padding: 12px 16px;
  border: 1px solid var(--primary-blue, #0B4598);
  border-radius: 8px;
  background: #f0f9ff;
  color: var(--primary-blue, #0B4598);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--fontMain, Poppins), sans-serif;
`

